module.exports = __webpack_public_path__ + "media/logo-izee.ecb1e31e.png";